"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetworkConfig = exports.SUPPORTED_CHAINS = exports.networkConfigs = void 0;
exports.networkConfigs = {
    'constantine-3': {
        provider: 'https://rpc.constantine.archway.tech:443',
        contracts: {
            factory: {
                address: 'archway1sp04kgz5cp4jheecmvee7qsv4a7v847eqy7cc08wj60axzx4tpuqt38l9p',
                code_id: 1458,
            },
        },
        settings: {
            name: 'Constantine',
            explorer: 'https://testnet.mintscan.io/archway-testnet',
            testnet: true,
            live: true,
        },
        currency: {
            coinDenom: 'CONST',
            coinMinimalDenom: 'aconst',
            coinDecimals: 18,
            coinGeckoId: 'constantine-network',
        },
    },
    'archway-1': {
        provider: 'https://rpc.mainnet.archway.io:443',
        contracts: {
            factory: {
                address: 'archway1f9cq084k3f0l5ay8mehtnw78xa3707se6yxvay60vplmh676d7rqzmza0r',
                code_id: 178,
            },
        },
        settings: {
            name: 'Constantine',
            explorer: 'https://archgregator.online/',
            testnet: false,
            live: true,
        },
        currency: {
            coinDenom: 'ARCH',
            coinMinimalDenom: 'aarch',
            coinDecimals: 18,
            coinGeckoId: 'archway-network',
        },
    },
};
exports.SUPPORTED_CHAINS = Object.keys(exports.networkConfigs).map((conf) => conf);
function getNetworkConfig(networkId) {
    return exports.networkConfigs[networkId];
}
exports.getNetworkConfig = getNetworkConfig;
//# sourceMappingURL=index.js.map